import 'phaser'
import { IEntity } from '../entities/entitiesUtils'
import { entitiesUtils } from '../entities/entitiesUtils-sidecar'
import { createId } from '../main/common'
import { IJob } from './jobs'
import { l } from '../lib/imports'
import { jobLogger } from './jobLogger-sidecar'
import { common } from '../main/common-sidecar'

export interface IJobCreator extends IEntity {
  delay: number
  timesFailed: number
  job: IJob | null
  condition: () => boolean
  doCreate: () => IJob
}

const objs: IJobCreator[] = []
export function getAll() {
  return objs
}
export function findById(id: number) {
  return entitiesUtils.findById(id, objs)
}

export function create(
  condition: () => boolean,
  doCreate: () => IJob,
): IJobCreator {
  let id = createId()

  let obj: IJobCreator = {
    eType: 'job-creator',
    id,
    isDead: false,
    delay: 0,
    timesFailed: 0,
    job: null,
    condition,
    doCreate,
  }

  objs.push(obj)

  return obj
}

export function killAll() {
  objs.forEach((c) => {
    kill(c)
  })
}
export function kill(obj: IJobCreator) {
  obj.isDead = true
}

export function updateAll() {
  objs.forEach((c) => {
    update(c)
  })
  entitiesUtils.removeDead(objs, (c) => {})
}
function update(obj: IJobCreator) {}

// export function report() {
//   console.log('jobs report')
//   l.forEach(objs, (c) => {
//     console.log(c.type)
//     console.log(c)
//   })
// }

const getRandomDelay = () => {
  let delay = l.random(0.25, 1.5)
  return delay
}

export function pruneJob(job: IJob | null) {
  let c = job
  if (c && !c.isComplete && !c.isFailed && !c.isDead) {
    return c
  }
  return null
}

export function pruneJobs(jobs: IJob[]) {
  return l.filter(jobs, (c) => !c.isComplete && !c.isFailed && !c.isDead)
}
export function runMulti(jobCreators: IJobCreator[]) {
  let firstJob: IJob | null = null
  let ds = common.getUpdateDeltaScaled()
  for (let i = 0; i < jobCreators.length; i++) {
    let jc = jobCreators[i]
    if (jc.isDead) {
      continue
    }
    if (jc.job) {
      if (jc.job.isFailed) {
        jc.timesFailed++
        jc.delay += getRandomDelay() * jc.timesFailed
        if (jc.delay > 2) {
          jc.delay = 2 + getRandomDelay()
        }
        jc.job = null
      } else if (jc.job.isComplete) {
        jc.delay = 0
        jc.job = null
      }
    } else {
      jc.delay -= 1 * ds
      if (jc.delay <= 0) {
        if (!jc.condition()) {
          jc.delay = getRandomDelay()
        } else {
          jc.job = jc.doCreate()
        }
      }
    }
    if (!firstJob && jc.job) {
      firstJob = jc.job
      break
    }
  }
  return firstJob
}

export function destroyAll(
  jobCreators: IJobCreator[],
  job: IJob | null = null,
) {
  for (let i = 0; i < jobCreators.length; i++) {
    let jc = jobCreators[i]
    jc.isDead = true
    if (jc.job) {
      jobLogger.cancelJob(jc.job, 'killed obj')
      jc.job = null
    }
  }
  if (job) {
    jobLogger.cancelJob(job, 'killed obj')
  }
  return null
}
